import axios from 'axios';
import { serviceUrl } from '../../App';

export const addusers = (obj: Object,token:string) => {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}` 
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL + `auth/register`,
    obj,
    { headers }
  );
};
export const editusers = (obj: Object,token:string) => {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}` 
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL + `auth/edit`, obj, {
    headers,
  });
};
export const deleteusers = (obj: Object, token: string) => {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL + `auth/delete-users`,
    obj,
    { headers }
  );
};
export const forgetPassword = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL + `auth/forget-password`,
    obj,
    { headers }
  );
};
export const getusers = () => {
  return axios.get(process.env.REACT_APP_API_GLOBAL_URL + `auth/users`);
};
